import { BehaviorSubject } from 'rxjs';
import { LocationSelector, StateRecord } from '../types/location';

export const locationSelector$ = new BehaviorSubject<LocationSelector>(LocationSelector.NONE);

export const openLocationSelector = (type: LocationSelector) => {
  locationSelector$.next(type);
};

export const closeLocationSelector = () => {
  locationSelector$.next(LocationSelector.NONE);
};

export function getStateFullName(abbreviation: string, states: StateRecord[]): string | undefined {
  const state = states.find((state) => state.abbreviation === abbreviation.toUpperCase());
  return state ? state.value : undefined;
}

export function getStateAbbreviation(fullName: string, states: StateRecord[]): string | undefined {
  const state = states.find((state) => state.value.toLowerCase() === fullName.toLowerCase());
  return state ? state.abbreviation : undefined;
}
